import Collector from './components/CollectorModal';
import * as reducer from './actions';

const namespace = reducer.namespace;
export { namespace, Collector, reducer };
